import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import environment from "src/utils/environment";

const MINIMUM_VOLUME_DIFFERENCE_TO_UPDATE = 0.08;

const Bar = ({ scale }) => (
  <Box
    transform={`scaleY(${scale})`}
    width={environment.isBibino ? ["6px", "7px", "8px"] : ["4px", "5px", "6px"]}
    height={
      environment.isBibino ? ["6px", "7px", "8px"] : ["4px", "5px", "6px"]
    }
    bg="primary"
    borderRadius={environment.isBibino ? `4px` : `2px`}
    mr="3px"
    sx={{
      "&:last-child": {
        mr: "0px"
      }
    }}
  />
);

export default class VoiceAnimation extends React.PureComponent {
  state = {
    volume: 0
  };

  componentDidMount(prevProps, prevState) {
    this.props.noiseMeter.on("change", this.updateVolume);
  }
  componentWillUnmount() {
    this.props.noiseMeter.off("change", this.updateVolume);
  }

  updateVolume = () => {
    const volumeUpdate = Math.min(7, this.props.noiseMeter.getVolume());
    if (volumeUpdate === 0 && this.state.volume === 0) return;
    const volumeDifference = Math.abs(this.state.volume - volumeUpdate);
    if (
      volumeDifference <= MINIMUM_VOLUME_DIFFERENCE_TO_UPDATE &&
      volumeUpdate > 0.05
    ) {
      return;
    }
    this.setState({ volume: volumeUpdate });
  };

  render() {
    const { volume } = this.state;
    return (
      <Flex alignItems="center">
        <Bar scale={1 + 1 * volume} />
        <Bar scale={1 + 6 * volume} />
        <Bar scale={1 + 4 * volume} />
        <Bar scale={1 + 2 * volume} />
      </Flex>
    );
  }
}
